<div class="card-icon">
  <ng-content select="[luiTopIconCardIcon]"></ng-content>
</div>
<div class="card-header">
  <ng-content select="[luiTopIconCardHeader]"></ng-content>
</div>
<div
  *ngIf="body"
  [class.h-100]="fillUsing === 'body'"
  [@expansion]="
    (body.openedChanged | async) || body.opened ? 'expanded' : 'collapsed'
  "
>
  <div class="card-body" [class]="body.additionalClass">
    <ng-content select="[luiTopIconCardBody]"></ng-content>
  </div>
</div>
<div
  class="card-footer d-flex"
  *ngIf="footer"
  [class.h-100]="fillUsing === 'footer'"
>
  <ng-content select="[luiTopIconCardFooter]"></ng-content>
</div>
<div *ngIf="loading" class="loading-container">
  <lui-loading-overlay></lui-loading-overlay>
</div>
